export const setCookie = (name: string, value: string, iat: number) => {
  sessionStorage.setItem(name, value);
};

export const getCookie = (name: string) => {
  const sessionVal = sessionStorage.getItem(name);
  if (sessionVal !== null) {
    return sessionVal;
  }

  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === " ")
      cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0)
      return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
};

export const deleteCookie = (name: string) => {
  sessionStorage.removeItem(name);
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

export const hasCookie = (name: string) => {
  const val = getCookie(name);
  if (val === "undefined" || val === null || val === "") {
    return false;
  } else if (typeof val === "undefined") {
    return false;
  } else {
    return true;
  }
};
